(async function () {
  const member = await Shopify.functions.getMemberFromStorage();
  Shopify.functions.showMemberSections(member);

  const pointsElements = document.querySelectorAll('.loyalty-member-points');

  if (member) {
    const points = member.points;
    pointsElements.forEach((element) => {
      element.innerHTML = points;
    });
  }
})();
